<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.userId" class="input-with-select" size="small" placeholder="请输入用户ID"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.joinType" placeholder="请选择" size="small">
                        <el-option label="不限制参与度" value=""></el-option>
                        <el-option label="仅看发起且参与了活动的" :value="3"></el-option>
                        <el-option label="仅看发起了活动的" :value="4"></el-option>
                        <el-option label="仅看参与了活动的" :value="5"></el-option>
						<el-option label="仅看发起了活动但未参与的" :value="1"></el-option>
						<el-option label="仅看参与了活动但未发起的" :value="2"></el-option>
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isGotCoupon" placeholder="请选择" size="small">
				        <el-option label="不限制是否领取了优惠券" value=""></el-option>
				        <el-option label="仅看领取了的" :value="1"></el-option>
				        <el-option label="仅看未领取的" :value="0"></el-option>
				    </el-select>
				</el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.isUsedCoupon" placeholder="请选择" size="small">
				        <el-option label="不限制是否使用了优惠券" value=""></el-option>
				        <el-option label="仅看使用了的" :value="1"></el-option>
				        <el-option label="仅看未使用的" :value="0"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
					<el-button type="primary" icon="el-icon-download" size="small" :loading="downLoading" @click="download" >导出</el-button>
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="用户（ID 名称）" min-width="180">
					<template slot-scope="scope">
						{{scope.row.userId}} <span class="color-danger">（{{scope.row.userName}}）</span>
					</template>
				</el-table-column>
                <el-table-column prop="joinType" label="参与度" >
					<template slot-scope="scope">
						{{scope.row.joinType ==1 ? '仅发起了活动' : scope.row.joinType ==2 ? '仅参与了活动' : '发起且参与了活动'}}
					</template>
				</el-table-column>
                <el-table-column label="参与时间" :min-width="200">
					<template slot-scope="scope">
						<p>发起活动：<span v-if="scope.row.launchTime">{{`${scope.row.launchTime}`}}</span></p>
						<p>参与活动：<span v-if="scope.row.joinTime">{{`${scope.row.joinTime}`}}</span></p>
					</template>
				</el-table-column>
                <el-table-column prop="isNew" label="是否新用户">
					<template slot-scope="scope">
						{{scope.row.isNew ? '是' : '否'}}
					</template>
				</el-table-column>
                <el-table-column prop="couponStatus" label="是否领取优惠券" >
					<template slot-scope="scope">
						{{scope.row.userCouponId ? '是' : '否'}}
					</template>
				</el-table-column>
                <el-table-column prop="userCouponId" label="是否使用优惠券">
					<template slot-scope="scope">
						{{scope.row.couponStatus && scope.row.couponStatus == 1 ? '是' : '否'}}
					</template>
				</el-table-column>				
				<el-table-column prop="trackPath" label="跟踪参数"></el-table-column>
				<el-table-column label="UV">
				    <template slot-scope="scope">
				        <p>秀动：<span>{{`${scope.row.uv}`}}</span></p>
				        <p>百度：<span>{{`${scope.row.bdUv}`}}</span></p>
				    </template>
				</el-table-column>
				<el-table-column label="PV">
				    <template slot-scope="scope">
				        <p>秀动：<span>{{`${scope.row.pv}`}}</span></p>
				        <p>百度：<span>{{`${scope.row.bdPv}`}}</span></p>
				    </template>
				</el-table-column>
				<el-table-column label="注册转化">
				    <template slot-scope="scope">
				        <p>注册人数：{{`${scope.row.registerCount}`}}</p>
				        <p>转化率：{{`${scope.row.userCr}`}}</p>
				    </template>
				</el-table-column>
				<el-table-column label="订单转化">
				    <template slot-scope="scope">
				        <p>下单人数：{{`${scope.row.orderUserCount}`}}</p>
				        <p>转化率：{{`${scope.row.orderCr}`}}</p>
				    </template>
				</el-table-column>
				<el-table-column label="订单">
				    <template slot-scope="scope">
				        <p>订单数：{{`${scope.row.orderCount}`}}</p>
				        <p>销售额：{{`${scope.row.saleAmount}`}}</p>
				    </template>
				</el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">                        
						<el-link :href="`/user/fans/edit/${scope.row.userId}`" class="blue"  target="_blank">查看详情</el-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        
    </div>
</template>

<script>
import {downloadFileTmp} from '@/assets/js/commonApi.js';
const defaultParams = {
    pageNo: 1,    
    userId:'',
    isGotCoupon: '',
	isUsedCoupon:'',
	joinType:''
}
export default {
    components:{},
	props:{
	    id: {
	        type: [Number, String],
	        default: ""
	    }
	},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                userId: this.$route.query.userId || '',
                isGotCoupon: this.$route.query.searchValue || '',
                isUsedCoupon: parseInt(this.$route.query.status) || '',
				joinType: parseInt(this.$route.query.status) || '',
            },
            listLoading: true,
			downLoading:false
			
          
        }
    },
    mounted() {
        this.getDataList();
    },
    methods: {
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/expand/userList",
                method: "POST",
                data: {
                    ...this.params,
					id:this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
                   
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
		async download(){
		    let filePath;
		    this.downLoading = true;
		    const res = await this.$request({
		        url:'/expand/export',
		        method: 'post',
		        data: {
		            ...this.params,
		            id:this.id
		        },
		    })
		        .catch(err => {
		            this.$message({message: err.message, type: 'error'});
		        })
		    const{state,msg,result} = res.data;
		    if(state == 1 && result){
		        filePath = result.url;
		    }else{
		        this.downLoading = false;
		        return this.$message.error(msg || '下载失败');
		    }   
		
		    await downloadFileTmp(filePath,'膨胀红包'+this.id+'参与用户.'+this.$utils.getFileType(filePath));
		
		    this.downLoading = false;
		},
    }
}
</script>

<style lang="scss" scoped>
.blue{
   color:#409eff;
   text-decoration:none;
}
</style>